import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { RocketIcon, CheckCircle2Icon, ArrowRightIcon, FileTextIcon, MegaphoneIcon, MailIcon, NetworkIcon, ZapIcon } from 'lucide-react';
export function ComboLaunchLanding() {
  return <div className="min-h-screen bg-slate-900 text-slate-50 font-sans selection:bg-indigo-500/30" data-id="element-870">
      {/* Navbar */}
      <nav className="border-b border-slate-800 bg-slate-900/50 backdrop-blur-md sticky top-0 z-50" data-id="element-871">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-872">
          <div className="flex items-center gap-2 font-bold text-xl tracking-tight" data-id="element-873">
            <RocketIcon className="w-6 h-6 text-indigo-500" data-id="element-874" />
            ComboLaunch <span className="text-indigo-500" data-id="element-875">AI</span>
          </div>
          <div className="flex items-center gap-4" data-id="element-876">
            <Link to="/app/dashboard" className="text-sm font-medium text-slate-300 hover:text-white hidden sm:block" data-id="element-877">
              Iniciar Sesión
            </Link>
            <Link to="/app/dashboard" className="bg-indigo-600 hover:bg-indigo-500 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors" data-id="element-878">
              Probar Gratis
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="relative pt-24 pb-32 overflow-hidden" data-id="element-879">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[500px] bg-indigo-600/20 rounded-full blur-[120px] -z-10 pointer-events-none" data-id="element-880"></div>

        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-881">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-882">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-300 text-sm font-medium mb-8" data-id="element-883">
              <ZapIcon className="w-4 h-4" data-id="element-884" /> Para creadoras gastronómicas
            </div>
            <h1 className="text-5xl md:text-7xl font-black tracking-tight text-white mb-6 leading-tight" data-id="element-885">
              De eBook de comida a negocio vendiendo en{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-purple-400" data-id="element-886">
                24 horas.
              </span>
            </h1>
            <p className="text-xl text-slate-400 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-887">
              ComboLaunch AI convierte cualquier producto digital gastronómico
              en un sistema de ventas completo: sales letter, ads, flyers,
              emails y funnel — sin agencia, sin diseñador, sin copywriter.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-888">
              <Link to="/app/dashboard" className="w-full sm:w-auto bg-indigo-600 hover:bg-indigo-500 text-white px-8 py-4 rounded-xl text-lg font-bold transition-colors flex items-center justify-center gap-2 shadow-lg shadow-indigo-500/25" data-id="element-889">
                Crear Mi Funnel Ahora <ArrowRightIcon className="w-5 h-5" data-id="element-890" />
              </Link>
              <p className="text-sm text-slate-500 sm:hidden" data-id="element-891">
                No requiere tarjeta de crédito
              </p>
            </div>
            <p className="text-sm text-slate-500 mt-4 hidden sm:block" data-id="element-892">
              Empieza gratis. No requiere tarjeta de crédito.
            </p>
          </motion.div>

          {/* Dashboard Preview Mockup */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="mt-20 relative mx-auto max-w-4xl" data-id="element-893">
            <div className="rounded-2xl border border-slate-700 bg-slate-800/50 p-2 shadow-2xl backdrop-blur-sm" data-id="element-894">
              <div className="rounded-xl overflow-hidden border border-slate-700 bg-slate-900 aspect-[16/9] relative flex items-center justify-center" data-id="element-895">
                <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/10 to-purple-500/10" data-id="element-896"></div>
                <div className="text-center space-y-4" data-id="element-897">
                  <RocketIcon className="w-16 h-16 text-indigo-500 mx-auto opacity-50" data-id="element-898" />
                  <p className="text-slate-400 font-medium" data-id="element-899">
                    Interfaz de ComboLaunch AI
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Features */}
      <section className="py-24 bg-slate-950" data-id="element-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-901">
          <div className="text-center mb-16" data-id="element-902">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-903">
              Todo lo que necesitas para vender
            </h2>
            <p className="text-lg text-slate-400" data-id="element-904">
              10 herramientas impulsadas por IA diseñadas específicamente para
              infoproductos de comida.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-905">
            {[{
            icon: SearchIcon,
            title: 'Product Analyzer',
            desc: 'Extrae la propuesta de valor y dolores de tu producto automáticamente.'
          }, {
            icon: FileTextIcon,
            title: 'Sales Letter Gen',
            desc: 'Cartas de venta largas y guiones VSL con frameworks probados.'
          }, {
            icon: MegaphoneIcon,
            title: 'Ad Copy Engine',
            desc: 'Conceptos de anuncios para Meta y TikTok listos para lanzar.'
          }, {
            icon: ImageIcon,
            title: 'Flyer Builder',
            desc: 'Copy y guías de diseño para tus posts de Instagram.'
          }, {
            icon: MailIcon,
            title: 'Email Sequences',
            desc: 'Funnels de correo para bienvenida, carritos abandonados y upsells.'
          }, {
            icon: NetworkIcon,
            title: 'Funnel Architect',
            desc: 'Diseña la estrategia completa de tu embudo visualmente.'
          }].map((feature, i) => <div key={i} className="bg-slate-900 border border-slate-800 p-6 rounded-2xl hover:border-indigo-500/50 transition-colors" data-id="element-906">
                <div className="w-12 h-12 bg-indigo-500/10 rounded-xl flex items-center justify-center mb-4" data-id="element-907">
                  <feature.icon className="w-6 h-6 text-indigo-400" data-id="element-908" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-909">
                  {feature.title}
                </h3>
                <p className="text-slate-400" data-id="element-910">{feature.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="py-24 bg-slate-900" data-id="element-911">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-912">
          <div className="text-center mb-16" data-id="element-913">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-914">
              Planes simples y transparentes
            </h2>
            <p className="text-lg text-slate-400" data-id="element-915">
              Escala tu negocio gastronómico al siguiente nivel.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-916">
            {/* Free */}
            <div className="bg-slate-800 border border-slate-700 rounded-3xl p-8" data-id="element-917">
              <h3 className="text-xl font-semibold text-white mb-2" data-id="element-918">Free</h3>
              <div className="flex items-baseline gap-1 mb-6" data-id="element-919">
                <span className="text-4xl font-bold text-white" data-id="element-920">$0</span>
                <span className="text-slate-400" data-id="element-921">/mes</span>
              </div>
              <p className="text-slate-400 text-sm mb-6" data-id="element-922">
                Para probar la herramienta antes de comprometerse.
              </p>
              <ul className="space-y-4 mb-8" data-id="element-923">
                {['1 producto activo', '3 generaciones/mes', 'Outputs con marca de agua'].map((feature, i) => <li key={i} className="flex items-start gap-3 text-slate-300 text-sm" data-id="element-924">
                    <CheckCircle2Icon className="w-5 h-5 text-indigo-500 shrink-0" data-id="element-925" />
                    {feature}
                  </li>)}
              </ul>
              <Link to="/app/dashboard" className="block w-full text-center bg-slate-700 hover:bg-slate-600 text-white py-3 rounded-xl font-medium transition-colors" data-id="element-926">
                Empezar Gratis
              </Link>
            </div>

            {/* Creator */}
            <div className="bg-indigo-600 border border-indigo-500 rounded-3xl p-8 relative transform md:-translate-y-4 shadow-2xl shadow-indigo-900/50" data-id="element-927">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-indigo-400 text-indigo-950 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-928">
                Más Popular
              </div>
              <h3 className="text-xl font-semibold text-white mb-2" data-id="element-929">Creator</h3>
              <div className="flex items-baseline gap-1 mb-6" data-id="element-930">
                <span className="text-4xl font-bold text-white" data-id="element-931">$29</span>
                <span className="text-indigo-200" data-id="element-932">/mes</span>
              </div>
              <p className="text-indigo-100 text-sm mb-6" data-id="element-933">
                Para vendedoras individuales de infoproductos.
              </p>
              <ul className="space-y-4 mb-8" data-id="element-934">
                {['3 productos activos', '50 generaciones/mes', 'Brand Voice Calibrator', 'Exportación sin marcas', 'Multi-idioma'].map((feature, i) => <li key={i} className="flex items-start gap-3 text-white text-sm" data-id="element-935">
                    <CheckCircle2Icon className="w-5 h-5 text-indigo-300 shrink-0" data-id="element-936" />
                    {feature}
                  </li>)}
              </ul>
              <Link to="/app/dashboard" className="block w-full text-center bg-white text-indigo-600 hover:bg-slate-50 py-3 rounded-xl font-bold transition-colors" data-id="element-937">
                Elegir Creator
              </Link>
            </div>

            {/* Pro */}
            <div className="bg-slate-800 border border-slate-700 rounded-3xl p-8" data-id="element-938">
              <h3 className="text-xl font-semibold text-white mb-2" data-id="element-939">Pro</h3>
              <div className="flex items-baseline gap-1 mb-6" data-id="element-940">
                <span className="text-4xl font-bold text-white" data-id="element-941">$79</span>
                <span className="text-slate-400" data-id="element-942">/mes</span>
              </div>
              <p className="text-slate-400 text-sm mb-6" data-id="element-943">
                Para coaches y creadores con catálogo.
              </p>
              <ul className="space-y-4 mb-8" data-id="element-944">
                {['10 productos activos', 'Generaciones ilimitadas', 'Funnel Architect completo', 'Soporte prioritario', 'Analytics y Scoring'].map((feature, i) => <li key={i} className="flex items-start gap-3 text-slate-300 text-sm" data-id="element-945">
                    <CheckCircle2Icon className="w-5 h-5 text-indigo-500 shrink-0" data-id="element-946" />
                    {feature}
                  </li>)}
              </ul>
              <Link to="/app/dashboard" className="block w-full text-center bg-slate-700 hover:bg-slate-600 text-white py-3 rounded-xl font-medium transition-colors" data-id="element-947">
                Elegir Pro
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-950 border-t border-slate-800 py-12" data-id="element-948">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-slate-500" data-id="element-949">
          <div className="flex items-center justify-center gap-2 font-bold text-xl tracking-tight text-white mb-4" data-id="element-950">
            <RocketIcon className="w-6 h-6 text-indigo-500" data-id="element-951" />
            ComboLaunch <span className="text-indigo-500" data-id="element-952">AI</span>
          </div>
          <p data-id="element-953">
            © {new Date().getFullYear()} ComboLaunch AI. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>
    </div>;
}